







































import { Component, Vue } from 'vue-property-decorator';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import eventBus from '@/utils/eventBus';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import OffersService from '@/api/OffersService';
import Typography from '@/components/atoms/Typography/Typography.vue';

@Component({
  components: {
    SideModalHeader,
    CustomSelect,
    FlexButton,
    Typography
  }
})
export default class SendOfferModal extends Vue {
  listOffers?: CustomSelectModel;
  offerSelected: CustomSelectOption[] = [];
  enable: boolean = false;
  categories: CustomSelectOption[] = [];
  service: OffersService = new OffersService();
  page: number = 0;
  isLoading: boolean = false;
  hasNoMoreOffer: boolean = false;
  title: string = '';
  debounce: any = {};
  disabled: boolean = true;
  message: string = '';
  created() {
    this.disabled = true;
    this.hasNoMoreOffer = false;
    this.loadOffers();
  }

  sendOffer() {
    eventBus.$emit('sendOffer', {
      message: this.message,
      offer: this.offerSelected[0]
    });
  }

  get initCategories() {
    return new CustomSelectModel(
      [new CustomSelectGroup(this.categories, '')],
      'Offers',
      true,
      false,
      false,
      true
    );
  }

  loadMore() {
    this.page += 5;
    this.loadOffers();
  }

  searchChange(event: string) {
    this.hasNoMoreOffer = false;
    this.page = 0;
    this.title = event;
    this.categories = [];
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.loadOffers();
    }, 300);
  }

  loadOffers() {
    if (this.hasNoMoreOffer) return;
    if (this.isLoading) return;
    this.isLoading = true;
    this.service
      .getOffers(
        '',
        '',
        `&status=active&skip=${this.page}&limit=10&search=${this.title}&`,
        ''
      )
      .then((res: any) => {
        let categories = res.data.items.filter(
          (item: any) => item.status === 'active'
        );
        categories = categories.map(
          (item: any) => new CustomSelectOption(item.id, item.title)
        );
        this.categories = categories;
        if (res.data.links.next === null) this.hasNoMoreOffer = true;
      })
      .catch(() => {})
      .finally(() => {
        this.isLoading = false;
      });
  }
  categoryChanged(item: CustomSelectOption[]) {
    this.disabled = false;
    this.offerSelected = item;
  }
}
